module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/trash_UB.3061a9d9.svg";